import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-private-policy-view',
    templateUrl: './private-policy-view.component.html',
    styleUrls: ['./private-policy-view.component.scss'],
    standalone: false
})
export class PrivatePolicyViewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
